<template>
    <div class="ma-0 pa-0">
        <v-card flat class="pa-0 ma-0">
            <v-card-text v-if="this.tipo == 'fotoperfil'" class="mt-1 text-center">
                <v-avatar v-if="!fototmp" :size="size">
                    <v-img v-if="fotoPerfil" :src="`data:image/png;base64,${fotoPerfil}`" />
                    <v-img v-else src="@/assets/img-user-profile.png" contain />
                </v-avatar>
                <v-avatar v-else :size="size">
                    <v-img v-if="fototmp" :src="`data:image/png;base64,${fototmp}`" />
                    <v-img v-else src="@/assets/blank-user-profile.png" />
                </v-avatar>
            </v-card-text>
            <v-card-text v-else-if="this.tipo == 'fotocarnet'" class="text-center">
                <v-avatar :size="(!fototmp && !fototmpcarnet && !fotoCarnet) ? '100%' : size" tile>
                    <v-img v-if="fototmp" :src="`data:image/png;base64,${fototmp}`" />
                    <v-img v-else-if="fototmpcarnet" :src="`data:image/png;base64,${fototmpcarnet}`"
                        class="d-flex justify-center" />
                    <v-img v-else-if="fotoCarnet" :src="`data:image/png;base64,${fotoCarnet}`" />
                    <v-img v-else src="@/assets/Instructivo-foto-carnet.png"></v-img>
                    <v-btn v-if="fototmpcarnet" :color="white" fab class="center-btn" @click="eliminarFoto">
                        <v-icon color="primary">
                            mdi-delete
                        </v-icon>
                    </v-btn>
                </v-avatar>
            </v-card-text>
            <!--                 
                        <v-avatar v-if="!fototmp" :size="size" tile>
                            <v-img v-if="fotoCarnet" :src="`data:image/png;base64,${fotoCarnet}`" />
                            <v-img v-else src="@/assets/blank-user-profile.png" />
                        </v-avatar>
                        <v-avatar v-else :size="size" tile>
                            <v-img v-if="fototmp" :src="`data:image/png;base64,${fototmp}`" />
                            <v-img v-else src="@/assets/blank-user-profile.png" />
                        </v-avatar>
                        -->
            <!--         <div v-if="$device.isDesktop" class="d-flex flex-row justify-center"> -->
            <v-card-text class="d-flex flex-column justify-center align-center ma-0 pa-0">
                <v-btn v-if="!fototmp" elevation="0" class="pa-5" width="163" @click="cambiarPanelFoto" color="primary">
                    <v-icon class="mr-2">mdi-camera-outline</v-icon>
                    TOMAR FOTO
                </v-btn>
                <InputButtonD titulo="seleccionar" icono="mdi-folder-outline" @fotoCargada="fotoSeleccionada"
                    :tipo="this.tipo">
                </InputButtonD>
            </v-card-text>
            <!-- <v-row v-else>
        <v-col class="mt-5">
            <InputButtonD titulo="seleccionar" icono="mdi-folder-outline" @fotoCargada="fotoSeleccionada"
            width="340" :tipo="this.tipo">
        </InputButtonD>
    </v-col>
</v-row> -->

            <!--  </div>
<div v-else-if="$device.isMobile" class="mt-5">
    <InputButtonD titulo="seleccionar" icono="mdi-folder-outline" @fotoCargada="fotoSeleccionada" width="340"
    :tipo="this.tipo">
</InputButtonD>
</div> -->
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import InputButtonD from '@/components/inputs/InputButtonDialogoFoto.vue'
import Alert from '@/components/alerts/Alertas.vue'
import ProfileAvatar from '@/assets/icons/profile-avatar.vue';

export default {
    components: {
        ProfileAvatar,
        InputButtonD,
        Alert,
    },
    data() {
        return {
            hasWebcam: false,
            isSelecting: false,
            seleccionada: false,
            size: '275',
            image: null,
            showCapture: false,
            imageSrc: '',
            titulo: '',
            icono: ''
        };
    },
    computed: {
        ...mapGetters('dataUser', ['fototmp', 'fotoPerfil', 'fotoCarnet', 'fototmpcarnet']),
        ...mapGetters('auth', ['emailAuth', 'nroafi', 'user', 'isAuthenticated']),
    },
    methods: {
        ...mapActions('dataUser', ['precargaFoto', 'precargaFotoCarnet']),
        ...mapActions('notificaciones', ['showSnack']),

        eliminarFoto() {
            this.precargaFotoCarnet("")
        },

        checkWebcam() {
            navigator.mediaDevices.enumerateDevices()
                .then(devices => {
                    devices.forEach(device => {
                        if (device.kind === 'videoinput') {
                            this.hasWebcam = true;
                        }
                    });
                }).catch(error => {
                    console.error('Error enumerating devices:', error);
                });
        },

        descartar() {
            this.precargaFoto('')
            this.seleccionada = false
        },
        guardar() {
            /* 
            this.subirFotoPerfil()
            this.showCapture = false
            */
        },
        cambiarPanelFoto() {
            this.$emit('abrirCamera')
        },
        fotoMostrada() {
            this.seleccionada = true
        },

        handleFileImport() {
            this.isSelecting = true

            // After obtaining the focus when closing the FilePicker, return the button state to normal
            window.addEventListener('focus', () => {
                this.isSelecting = false
            }, { once: true });

            // Trigger click on the FileInput
            try {
                this.$refs.uploader.click();
            } catch (error) {

            }
        },
        onFileChanged(e) {
            if (e.target.files[0]) {
                const maxAllowedSize = 5 * 1024 * 1024;
                const permitido = this.archivoPermitido(e.target.files[0].type)
                /*Maximum allowed size in bytes
                    5MB Example
                //Change first operand(multiplier) for your needs
                */
                if ((e.target.files[0].size < maxAllowedSize) && (permitido)) {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        //referencia al elemento canvas
                        let canvas = this.$refs.cv
                        //config
                        const ctx = canvas.getContext("2d");
                        //nueva imagen
                        const img = new Image
                        img.src = URL.createObjectURL(e.target.files[0])
                        img.onload = function () {
                            console.log(canvas.width)
                            console.log(canvas.height)
                            console.log(img.naturalWidth)
                            console.log(img.naturalHeight)
                            var hRatio = canvas.width / img.naturalWidth
                            var vRatio = canvas.height / img.naturalHeight
                            var ratio = Math.min(hRatio, vRatio)

                            var centerX = (canvas.width - img.width * ratio) / 2
                            var centerY = (canvas.height - img.height * ratio) / 2

                            ctx.clearRect(0, 0, canvas.width, canvas.height)

                            //ctx.drawImage(img, 0, 0, img.width, img.height, centerX, centerY, img.width * ratio, img.height * ratio);
                            ctx.drawImage(img, 0, 0, img.width, img.height, centerX, centerY, img.width * ratio, img.height * ratio);

                        }
                        let dataURL = canvas.toDataURL('img/png');
                        const arr = dataURL.split(',');
                        console.log(dataURL)
                        //this.addFotoCarnet(arr[1])
                    };
                    reader.readAsDataURL(e.target.files[0])
                } else {
                    this.showSnack({
                        type: '400',
                        message: 'archivo no permitido. Debe ser menor a 5MB y en formato .pdf, .jpg, .jpeg o .png'
                    })
                }
                //,.jpg,.png,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document
                /*else {
                this.showSnack({
                    type: '400',
                    message: 'archivo no permitido. Debe ser menor a 5MB y en formato .pdf, .jpg, .jpeg o .png'
                })
                this.file = ''
                this.files = []
            }
             */

                //this.precargaFoto(this.selectedFile)

                //envio señal de fotoSeleccionada
                //this.$emit('haySeleccion')
                /*   const reader = new FileReader();
                  reader.onloadend = () => {
                      //referencia al elemento canvas
                      //let canvas = this.$refs.cv
                      //config
                      //const ctx = canvas.getContext("2d");
                      //nueva imagen
                      const img = new Image
                      img.src = URL.createObjectURL(this.selectedFile)
                      img.onload = function () {
                          console.log(canvas.width)
                          console.log(canvas.height)
                          console.log(img.naturalWidth)
                          console.log(img.naturalHeight)
                          var hRatio = canvas.width / img.naturalWidth
                          var vRatio = canvas.height / img.naturalHeight
                          var ratio = Math.min(hRatio, vRatio)
     
                          var centerX = (canvas.width - img.width * ratio) / 2
                          var centerY = (canvas.height - img.height * ratio) / 2
     
                          ctx.clearRect(0, 0, canvas.width, canvas.height)
     
                          //ctx.drawImage(img, 0, 0, img.width, img.height, centerX, centerY, img.width * ratio, img.height * ratio);
                          ctx.drawImage(img, 0, 0, img.width, img.height, centerX, centerY, img.width * ratio, img.height * ratio);
     
                      }
                      let dataURL = canvas.toDataURL('img/png');
                      const arr = dataURL.split(',');
                      console.log(dataURL)
                      this.addFotoCarnet(arr[1])
                  };
                  reader.readAsDataURL(this.selectedFile) */
            }

        },
        archivoPermitido(type) {
            // archivos permitidos (jpeg/jpg/png/docX/pdf/tiff/jfif)
            //,.jpg,.png,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document	
            //console.log("tipo Archivo -> " + archivo.type);
            //console.log("Archivo -> " + archivo.name);
            switch (type) {
                case "image/png":
                case "image/jpg":
                case "image/jpeg":
                case "application/pdf":
                    break;
                default:
                    return false
                /*                     msg = "Error: El tipo de Archivo NO está permitido!. Permitidos (jpeg/jpg/png/pdf)."; */
            }
            return true
        },
        fotoSeleccionada() {
            // console.log('se selecciono una foto')
            this.$emit('cerraDialogo')
        }

    },
    mounted() {
        this.checkWebcam()

        if (this.$vuetify.breakpoint.mobile) {
            this.titulo = 'capturar'
            this.icono = 'mdi-camera-outline'
        } else {
            this.titulo = 'subir'
            this.icono = 'mdi-folder-outline'
        }

    },
    props: ['tipo'],
}
</script>

<style>
.image-container {
    position: relative;
    /* Necesario para posicionar elementos hijos */
}

.center-btn {
    position: absolute;
    /* Posiciona el botón relativo al contenedor */
    top: 50%;
    /* A mitad del contenedor */
    left: 50%;
    /* A mitad del contenedor */
    transform: translate(-50%, -50%);
    /* Centra el botón exactamente */
}
</style>